import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { VegetationIndexState } from './types';
import { Module } from 'vuex';
import { RootState } from '../types';

export const vegetationIndex: Module<VegetationIndexState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
